import { useCallback, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../Redux/Hooks";
import {
  getWhatsAppTemplates,
  createWhatsAppTemplate,
  syncWhatsAppTemplate,
  deleteWhatsAppTemplate,
  getWhatsAppTemplateDetail,
} from "../Redux/ApiCalls/Dashboard/WhatsAppAPI";
import type { CreateWhatsAppTemplatePayload } from "../Data/whatsapp.dto";

/**
 * Hook for WhatsApp templates: list, create, sync, delete, loading, error, refresh.
 */
export function useTemplates() {
  const dispatch = useAppDispatch();
  const { templates, loading, error, isError, syncingTemplateId, deletingTemplateId } =
    useAppSelector((state) => state.whatsapp);

  const refresh = useCallback(
    (status?: string) => {
      dispatch(getWhatsAppTemplates(status));
    },
    [dispatch]
  );

  const createTemplate = useCallback(
    (payload: CreateWhatsAppTemplatePayload) => {
      return dispatch(createWhatsAppTemplate(payload));
    },
    [dispatch]
  );

  const syncTemplate = useCallback(
    (templateId: string) => {
      return dispatch(syncWhatsAppTemplate(templateId));
    },
    [dispatch]
  );

  const deleteTemplate = useCallback(
    (templateId: string, local_only?: boolean) => {
      return dispatch(deleteWhatsAppTemplate({ templateId, local_only }));
    },
    [dispatch]
  );

  const getTemplateDetail = useCallback(
    (templateId: string) => {
      return dispatch(getWhatsAppTemplateDetail(templateId));
    },
    [dispatch]
  );

  useEffect(() => {
    dispatch(getWhatsAppTemplates(undefined));
  }, [dispatch]);

  return {
    templates,
    loading,
    error,
    isError,
    syncingTemplateId,
    deletingTemplateId,
    refresh,
    createTemplate,
    syncTemplate,
    deleteTemplate,
    getTemplateDetail,
  };
}
